import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Collapse,
  IconButton,
  Typography,
  Grid,
  TextField,
  Box
} from '@mui/material';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FrequentlyAskedQuestions = ({
  formData,
  handleChange,
  expanded,
  toggleSection
}) => {
  return (
    <Card
      elevation={3}
      sx={{
        mb: 3,
        borderLeft: '6px solid #2196f3',
        borderRadius: 2,
        backgroundColor: '#f9f9f9'
      }}
    >
      <CardHeader
        avatar={<QuestionAnswerIcon sx={{ color: '#2196f3' }} />}
        title={
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>
            Frequently Asked Questions
          </Typography>
        }
        action={
          <IconButton onClick={() => toggleSection('faq')}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
        sx={{
          backgroundColor: '#f0f0f5',
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          py: 1.5,
          px: 2
        }}
      />
      <Divider />
      <Collapse in={expanded}>
        <CardContent sx={{ px: 3, py: 2 }}>
          <Grid container spacing={4}>
            {/* FAQ 1 */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="FAQ 1 Question"
                name="faq_1_question"
                value={formData.faq_1_question}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                helperText="Enter the first commonly asked question"
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: '#fff',
                    '& fieldset': { borderColor: '#90caf9' },
                    '&:hover fieldset': { borderColor: '#64b5f6' },
                    '&.Mui-focused fieldset': { borderColor: '#2196f3' }
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="FAQ 1 Answer"
                name="faq_1_answer"
                value={formData.faq_1_answer}
                onChange={handleChange}
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                helperText="Provide a clear and concise answer"
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: '#fff',
                    '& fieldset': { borderColor: '#90caf9' },
                    '&:hover fieldset': { borderColor: '#64b5f6' },
                    '&.Mui-focused fieldset': { borderColor: '#2196f3' }
                  }
                }}
              />
            </Grid>

            {/* FAQ 2 */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="FAQ 2 Question"
                name="faq_2_question"
                value={formData.faq_2_question}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                helperText="Enter the second commonly asked question"
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: '#fff',
                    '& fieldset': { borderColor: '#90caf9' },
                    '&:hover fieldset': { borderColor: '#64b5f6' },
                    '&.Mui-focused fieldset': { borderColor: '#2196f3' }
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="FAQ 2 Answer"
                name="faq_2_answer"
                value={formData.faq_2_answer}
                onChange={handleChange}
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                helperText="Provide a clear and concise answer"
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: '#fff',
                    '& fieldset': { borderColor: '#90caf9' },
                    '&:hover fieldset': { borderColor: '#64b5f6' },
                    '&.Mui-focused fieldset': { borderColor: '#2196f3' }
                  }
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default FrequentlyAskedQuestions;
